import { Component, OnDestroy, OnInit } from '@angular/core';
import { User } from 'anchor-shared/lib/model/entity/user';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ContainsSubscriptions } from '../../../core/services/interfaces/contains-subscriptions';
import { UserDAO } from '../../../core/services/dao/userDAO';
import { AuthService } from '../../../core/services/auth.service';
import { ChickenTestDialogService } from '../../shared/dialogs/chicken-test-dialog/chicken-test-dialog.service';
import { unsubscribeFromAll } from '../../../core/pure-functions/rx-helper';
@Component({
  selector: 'app-captain-deletion-request',
  templateUrl: './captain-deletion-request.component.html',
  styleUrls: ['./captain-deletion-request.component.scss'],
})
export class CaptainDeletionRequestComponent
  implements OnInit, ContainsSubscriptions, OnDestroy
{
  user: User;
  subs: Subscription[] = [];
  isCaptainUser = false;
  constructor(
    private userDAO: UserDAO,
    private authService: AuthService,
    private chickenTestDialog: ChickenTestDialogService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.user = this.userDAO.getCurrentUser();
    this.determineIfUserIsCaptain();
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  determineIfUserIsCaptain(): void {
    if (this.user && this.user.captain) {
      this.isCaptainUser = true;
    }
  }

  deleteAccount() {
    const openSub = this.chickenTestDialog
      .open(
        'Are you sure you want to delete your account?',
        'Ok - Delete account',
        'Cancel',
        null,
        'Once your request is completed, you will not be able to regain access to your account',
        'Account deletion',
      )
      .subscribe((affirmative) => {
        if (affirmative) {
          const delSub = this.userDAO.deletionRequest().subscribe((deleted) => {
            if (deleted) {
              const sub = this.authService.logout().subscribe(
                (data) => {
                  this.router.navigate(['home']);
                },
                (error) => {
                  console.log('logout failed');
                },
              );
              this.subs.push(sub);
            }
          });
          this.subs.push(delSub);
        }
      });
    this.subs.push(openSub);
  }
}
